import type { FunctionComponent } from 'react';

export const ChevronLeft: FunctionComponent = () => {
  return (
    <svg
      fill="currentColor"
      height="13"
      viewBox="0 0 8 13"
      width="8"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m6.73047.592759c.36263.36263.38853.934451.0777 1.326971l-.0777.08724-4.29279 4.29223 4.29281 4.2935c.36263.3627.38853.9345.07771 1.327l-.07771.0873c-.36263.3626-.93447.3885-1.32699.0776l-.08722-.0776-5.00001-5.00004c-.3626298-.36263-.3885324-.9345-.077707-1.32702l.077707-.0872 4.99998-4.999981c.39053-.390524 1.02369-.390525 1.41422 0z" />
    </svg>
  );
};
